import FAQ from "@/components/FAQ";
import Help from "@/components/Help";
import Instructor from "@/components/Masterclass/Instructor";
import NewLeadForm from "@/components/Masterclass/New-lead-form";
import Overview from "@/components/Masterclass/Overview";
import Reviews from "@/components/Masterclass/Reviews";
import Layout from "@/components/layout";
import { TimerOnlyText } from "@/components/pages/timer/timer";
import { Button } from "@/components/ui/button";
import { CLASS_TYPE } from "@/pages/bootcamps";
import { cn } from "@/utils/cn";
import webengage from "@/webengage";
import {
  ChevronRightIcon,
  ClockIcon,
  PuzzlePieceIcon,
  TrophyIcon,
  VideoCameraIcon,
} from "@heroicons/react/24/outline";
import {
  ArrowLeftIcon,
  CalendarIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  PlayCircleIcon,
  StarIcon,
  UserIcon,
} from "@heroicons/react/24/solid";
import axios from "axios";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import mixpanel from "@/utils/mixpanel";
import Image from "next/image";
import { audienceTypes } from "@/components/Bootcamp/Overview";
import { Card, CardContent } from "@/components/ui/card";
import Head from "next/head";
import Breadcrumb from "@/components/BreadCrumb";

export async function getServerSideProps(context: any) {
  const masterclassSlug = context.params.id;

  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/masterclass-slot-details/${masterclassSlug}`,
      {
        headers: {
          "Accept-Encoding": "gzip",
        },
      }
    );
    return {
      props: {
        data: data.data,
        masterclassSlug,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      props: {
        data: {},
      },
    };
  }
}

type SpecialPage = {
  title: string;
  desc: string;
};

const SPECIAL_PAGES: Record<string, SpecialPage> = {
  "algo-trading-using-chatgpt-with-aseem-singhal--xgs5jtgx2": {
    title: "Algo Trading Masterclass | Using ChatGPT with Aseem Singhal",
    desc: "Master algorithmic trading with ChatGPT in this exclusive class by Aseem Singhal. Learn advanced AI tools & strategies to change your trading approach.",
  },
  "big-learning-days--bld--tradewise-yxv9q5ejb": {
    title: "Big Learning Days (BLD) | Intensive Trading Program by Tradewise",
    desc: "Join Tradewise's Big Learning Days (BLD), an immersive trading program featuring expert-led sessions, cutting-edge strategies, and live market insights.",
  },
  "index-option-trading-with-jagpreet-singh-narula-57nw7q3iv": {
    title: "Index Option Trading Masterclass | With Jagpreet Singh Narula",
    desc: "Learn expert strategies in index option trading with Jagpreet Singh Narula. Join this masterclass by Tradewise for actionable insights & proven techniques.",
  },
  "master-the-markets--the-laxman-rekha-way-8scs4gosr": {
    title: "Option Trading Masterclass | Master the Markets with Gopal Verma",
    desc: "Join Tradewise's Option Trading Masterclass and master the Laxman Rekha trading strategy. Learn proven techniques to excel in options trading markets.",
  },
  "tfu-x-algofox-trading-course-with-kushal-gu2j4w1go": {
    title: "Algo Trading Course With Kushal & Archit | Tradewise",
    desc: "Join the TFU x Algofox Trading Course with Kushal. Learn advanced strategies, harness Algo trading, and elevate your market expertise. Enroll now",
  },
  "unlocking-profits-and-consistency-in-swing-trading-rruvs9zny": {
    title: "Swing Trading Masterclass - 10X Your Capital With Prabhu Selvaraj",
    desc: "Learn the secrets to profitable and consistent swing trading. Join our course and transform your trading approach with expert guidance.",
  },
  "swing-trading-mentorship-program-with-mr-kamal-preet-singh-54ois0rvv": {
    title: "Learn Swing Trading With Kamalpreet | Tradewise",
    desc: "Master swing trading with Mr. Kamal Preet Singh's mentorship program. Learn expert strategies, boost your skills, and achieve consistent success.",
  },
  "algo-trading-with-vikram-kashikar-21e0a0mow": {
    title: "Masterclass On Algo Trading Using Excel - Vikram Kashikar",
    desc: "Learn algorithmic trading from Vikram Kashikar. Discover advanced strategies and tools to elevate your trading skills. Enroll in the course today",
  },
  "ultimate-options-trading-program-with-chirag-jain-c92mneyf4": {
    title: "Options Trading for Beginners - by Chirag Jain | Tradewise",
    desc: "Master options trading with Chirag Jain's program. Perfect for beginners, learn essential strategies and build a strong foundation. Join today",
  },
  "bx-of-crypto-currency-with-munish-batra-m4lfwkuua": {
    title: "Free Crypto Trading Class with Munish Batra - Tradewise",
    desc: "Learn crypto trading for free with expert Munish Batra. Gain insights, master strategies, and start trading smarter. Reserve your spot today",
  },
  "https://tradewiseapp.com/masterclasses/algo-trading-using-chatgpt-with-aseem-singhal--xgs5jtgx2":
    {
      title: "Algo Trading with ChatGPT - Learn with Aseem Singhal",
      desc: "Discover how to use ChatGPT for algorithmic trading with Aseem Singhal. Learn AI-driven strategies to automate and enhance your trading success",
    },
  "scalping--rgfjem79a": {
    title: "Scalping Trading Masterclass With Pankaj Sahu | Tradewise",
    desc: "Master scalping trading with expert guidance. Learn fast-paced strategies to maximize profits and trade smarter. Enroll in the course now",
  },
  "masterclass-on-forex-trading-with-jawaad-hussain-nj39jhbn6": {
    title: "Free Forex Trading Class with Jawaad Hussain | Tradewise",
    desc: "Learn forex trading for free with Jawaad Hussain. Master key strategies and gain the skills to trade confidently. Reserve your spot today",
  },
  "maestro-swing-trading-system-s1u5wsmgq": {
    title: "Free Swing Trading Course - Boost Your Trading Skills",
    desc: "Take our free swing trading course to discover proven strategies and enhance your trading success. Start learning and trading smarter today",
  },
  "how-to-double-your-profit-with-commodity-trading-l1zx60xdl": {
    title: "Free Commodity Trading Class By Hiral Shah | Tradewise",
    desc: "Join Hiral Shah's free class on commodity trading. Learn expert strategies to maximize profits and succeed in the commodities market. Sign up now",
  },
  "master-trading-from-basics-to-breakthroughs-6ms0hwi4r": {
    title: "Master Trading: From Basics to Breakthroughs | By Abhishek Bansal",
    desc: "Transform your trading skills with our master trading course. Cover everything from basics to breakthrough strategies for consistent success",
  },
  "build-your-trading-success-master-risk-market-dynamics-and-growth-8ka6ne028":
    {
      title: "Master Risk & Market Dynamics for Trading Success | Tradewise",
      desc: "Unlock trading success with strategies to manage risk and understand market dynamics. Grow your skills and trade confidently. Sign up today",
    },
  "the-holy-grail-of-trading-with-balakrishna--5wkhmpa7h": {
    title: "The Holy Grail of Trading: Master Order Flow Analysis",
    desc: "Unlock the secrets of order flow analysis with Balakrishna. Learn how to read market flow and enhance your trading strategies for consistent profits",
  },
  "masterclass-on-intraday-trading-with-jagpreet-singh-narula-4h8jq0m25": {
    title: "Free Intraday Trading Course By Jagpreet Singh | Tradewise",
    desc: "Learn intraday trading strategies in our free class. Get expert insights and tips to maximize your profits in fast-paced markets. Enroll today",
  },
  "masterclass-on-swing-trading-by-hemant-jain-dyehm87gn": {
    title: "Free Masterclass On Swing Trading With Hemant Jain | Tradewise",
    desc: "Join our free masterclass on swing trading. Learn key strategies, analyze market trends, and start making profitable trades. Register today",
  },
  "time-cycle-trading-and-gann-theory-iz1d5lo9s": {
    title: "Time Cycle Trading & Gann Theory Masterclass | Tradewise",
    desc: "Unlock powerful trading strategies with Time Cycle Trading and Gann Theory. Gain expert insights to enhance your market timing and trading success.",
  },
  "masterclass-on-energy-markets-with-rahul-gupta-2gccu2r9w": {
    title: "Energy Markets Masterclass with Rahul Gupta | Tradewise",
    desc: "Master the energy markets with expert Rahul Gupta. Learn key strategies and insights to succeed in the ever-changing energy market. ",
  },
  "cashflow-trading-strategy-5bsejshu7": {
    title: "Cashflow Trading Strategy Masterclass With Animesh Kumar",
    desc: "Learn the proven Cashflow Trading Strategy to maximize profits. Join our masterclass and discover how to trade smarter and build steady cash flow.",
  },
};

const TABS = {
  OVERVIEW: "overview",
  INSTRUCTOR: "instructor",
  REVIEW: "review",
  HELP: "help",
};

const TabsArray = [
  {
    img: "/tradewise/navbar/overview.svg",
    activeImg: "/tradewise/navbar/blue-overview.svg",
    tab: "overview",
  },
  {
    img: "/tradewise/navbar/instructor.svg",
    activeImg: "/tradewise/navbar/blue-instructor.svg",
    tab: "instructor",
  },
  {
    img: "/tradewise/navbar/phone.svg",
    activeImg: "/tradewise/navbar/blue-phone.svg",
    tab: "help",
  },
  {
    img: "/tradewise/navbar/review.svg",
    activeImg: "/tradewise/navbar/blue-review.svg",
    tab: "review",
  },
];

export default function Masterclass({
  data,
  masterclassSlug,
}: {
  data: any;
  masterclassSlug: string;
}) {
  const router = useRouter();
  const scrollToForm = router.query.register === "true";
  const [isActive, setIsActive] = useState(TABS.OVERVIEW);
  const [scroll, setScroll] = useState(false);
  const [offerEndTime, setOfferEndTime] = useState(
    dayjs().add(15, "minute").toDate()
  );
  const [expandTeacherInfo, setExpandTeacherInfo] = useState(false);
  const overviewRef = useRef<HTMLDivElement | null>(null);
  const instructorRef = useRef<HTMLDivElement | null>(null);
  const helpRef = useRef<HTMLDivElement | null>(null);
  const reviewRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isActive === TABS.OVERVIEW && overviewRef.current) {
      overviewRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (isActive === TABS.INSTRUCTOR && instructorRef.current) {
      instructorRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (isActive === TABS.HELP && helpRef.current) {
      helpRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (isActive === TABS.REVIEW && reviewRef.current) {
      reviewRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [isActive]);
  const [buttonVisibility, setButtonVisibility] = useState({
    button1Visible: true,
    button2Visible: false,
  });
  const button1Ref = useRef(null);
  const button2Ref = useRef(null);

  const isInViewport = (element: any) => {
    if (!element) return false;
    var bounding = element.getBoundingClientRect();

    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      const button1 = button1Ref.current;
      const button2 = button2Ref.current;
      const button1Visible = isInViewport(button1);
      const button2Visible = isInViewport(button2);

      setButtonVisibility({
        button1Visible,
        button2Visible,
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isInViewport]);

  useEffect(() => {
    if (scrollToForm) {
      setScroll(true);
    }
  }, [scrollToForm]);

  useEffect(() => {
    const _webengage = webengage();
    if (_webengage && data.masterClass) {
      _webengage.track("Masterclass viewed", {
        title: data.masterClass.title,
        industry: data.masterClass?.bootcamp?.teacher?.category?.name,
        fees: "free",
        instructor: data.masterClass?.bootcamp?.teacher.name,
        date: data?.startDateTime && new Date(data?.startDateTime),
        source: "Tradewise",
      });
    }
  }, []);
  const rating = data?.masterClass?.bootcamp?.teacher?.achievements?.rating;
  const students = data?.masterClass?.bootcamp?.teacher?.achievements?.students;
  const starArray = [1, 2, 3, 4, 5];

  return (
    <>
      <Head>
        <title>
          {SPECIAL_PAGES[masterclassSlug as any]?.title || "Masterclass"}
        </title>
        <meta
          name="description"
          content={
            SPECIAL_PAGES[masterclassSlug as any]?.desc ||
            `Join the ${data?.masterClass?.title} masterclass by ${
              data?.masterClass?.bootcamp?.teacher?.name
            }. Enhance your skills and knowledge in ${
              data?.masterClass?.bootcamp?.teacher?.category?.name || "trading"
            }.`
          }
        />
      </Head>
      <Layout footerClassName="max-md:pb-32">
        <Breadcrumb classNames="max-md:text-xs max-md:mb-2" />
        <div className="flex flex-col gap-2 font-sans relative">
          <div className="flex flex-row gap-4 justify-start items-start md:hidden">
            <ArrowLeftIcon
              className="w-5 h-5 hover:cursor-pointer"
              onClick={() => router.back()}
            />
            <h3 className="text-[#161C2B] max-w-[22rem] text-lg md:hidden">
              {data?.masterClass?.title}
            </h3>
          </div>
          <Image
            src={
              data?.masterClass?.bootcamp?.coverImage ||
              "/fallback-thumbnail.webp"
            }
            width={1920}
            height={1080}
            alt="bootcamp thumbnail"
            className="rounded-md shadow-[0_1px_4px_0px_rgba(0,0,0,0.16)] md:hidden"
          />
          <div className="flex flex-col gap-2 md:hidden font-medium">
            <div className="flex flex-row justify-between items-center w-full">
              <div className="flex flex-row justify-center items-center gap-1">
                <CalendarIcon className="w-5 h-5" />
                <p className="text-[#606060]">
                  {dayjs(data?.startDateTime)?.format("DD MMMM")} (
                  {dayjs(data?.startDateTime)?.format("dddd")})
                </p>
              </div>
              <div className="flex flex-row justify-center items-center gap-1 font-medium">
                <ClockIcon className="w-5 h-5" />
                <p className="text-[#606060]">
                  {dayjs(data?.startDateTime)?.format("hh:mm A")}
                </p>
              </div>
            </div>

            <div className="flex flex-row justify-between items-center w-full text-sm font-medium">
              <p className="text-[#606060] ">Intraday Trading</p>
              <div className="flex flex-row justify-center gap-1">
                <div className="flex flex-row justify-center items-center">
                  {rating
                    ? starArray.map((stars: number, index: number) => {
                        if (stars <= rating) {
                          return (
                            <StarIcon
                              key={index}
                              className="w-5 h-5 text-[#FFA135]"
                            />
                          );
                        } else {
                          return (
                            <StarIcon
                              key={index}
                              className="w-5 h-5 text-[#F9D4AB]"
                            />
                          );
                        }
                      })
                    : starArray.map((stars: number, index: number) => {
                        return (
                          <StarIcon
                            key={index}
                            className="w-5 h-5 text-[#FFA135]"
                          />
                        );
                      })}
                </div>
                <p className="text-[#606060]">
                  {rating ? rating : 5} (
                  {parseInt(students) > 1000
                    ? `${Math.floor(parseInt(students) / 1000)}k+`
                    : "10k+"}
                  )
                </p>
              </div>
            </div>
            <div className="flex flex-row justify-between items-center w-full">
              <div className="flex flex-row gap-1 justify-start items-center relative">
                <h4 className="text-[#FF7426] font-semibold text-lg">Free</h4>
                <div className="flex flex-col justify-center text-[#606060] text-sm before:content-[url('/masterclass-card-strike-through.svg')] before:absolute before:left-11 before:bottom-1">
                  ₹499
                </div>
              </div>
              <div className="flex flex-row gap-1">
                <p className="text-[#606060]">Offer Ends in:</p>
                <TimerOnlyText
                  tillDateTime={offerEndTime}
                  className="text-[#FF7426] font-semibold"
                />
              </div>
            </div>
          </div>
          <Button
            ref={button1Ref}
            className="md:hidden w-full rounded font-bold font-inter mb-2 h-12"
            onClick={() => {
              setScroll(true);
              mixpanel.track("register_now", {
                page_referrer: document.referrer,
                location: "top_cta",
                masterclass: data?.masterClass?.title,
                source: "astrolearn",
              });
            }}
          >
            Register Now
          </Button>
        </div>

        <div className="flex flex-row gap-12 max-xl:gap-10 max-lg:gap-5 max-md:hidden justify-center items-start font-inter">
          <div className="max-w-3xl max-xl:max-w-lg max-lg:max-w-md py-3 w-full flex flex-col justify-start items-start gap-4">
            <h3 className="text-[#161C2B] max-md:max-w-[22rem] max-w-2xl max-xl:max-w-xl max-lg:text-xl">
              {data?.masterClass?.title}
            </h3>
            <p className="text-[#161C2B]">{data?.masterClass?.description}</p>
            <Image
              src={
                data?.masterClass?.bootcamp?.coverImage ||
                "/fallback-thumbnail.webp"
              }
              width={980}
              height={560}
              alt={`${data?.masterClass?.title}-coverImage`}
              className="rounded-md shadow-[0_1px_4px_0px_rgba(0,0,0,0.16)]"
            />

            <div className="flex flex-row gap-8 justify-between items-center py-2 overflow-x-auto px-4 w-full hide_scrollbar">
              {TabsArray.map((item: any, index: number) => {
                return (
                  <div
                    className={`rounded-full tab-item w-24 border-none text-lg font-semibold flex flex-row max-lg:flex-col max-lg:gap-1 gap-2 justify-center items-center hover:cursor-pointer ${
                      isActive === item.tab
                        ? "!text-[#002082] tab-item-active"
                        : "!text-[#161C2B]"
                    }`}
                    onClick={() => {
                      setIsActive(item.tab);
                      mixpanel.track("view_info", {
                        location: "tab",
                        tab: item?.tab,
                      });
                    }}
                    key={index}
                  >
                    <Image
                      width={20}
                      height={20}
                      src={isActive === item.tab ? item.activeImg : item.img}
                      className={`${isActive === item.tab ? "scale-105" : ""} `}
                      alt="icon"
                    />
                    <small className="font-semibold">
                      {item.tab.substring(0, 1).toUpperCase() +
                        item.tab.substring(1, item.tab.length)}
                    </small>
                  </div>
                );
              })}
            </div>

            <div
              className="w-full flex flex-col justify-start items-start gap-4"
              ref={overviewRef}
            >
              <div
                className="prose prose-h1:text-[#002082] prose-h2:text-[#002082] prose-h2:text-[20px] prose-h2:font-semibold prose-p:text-[#161C2B] prose-p:text-base prose-li:text-base prose-li:text-[#161C2B] prose-ul:list-disc"
                dangerouslySetInnerHTML={{
                  __html: data?.masterClass?.learnings,
                }}
              ></div>

              <h4 className="text-[#002082] font-semibold">
                Who is this Masterclass for
              </h4>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {audienceTypes?.map((audience) => (
                  <Card
                    key={audience.type}
                    className={`${audience.bgColor} text-center`}
                  >
                    <CardContent className="p-4">
                      <Image
                        src={`/tradewise/${audience.type.toLowerCase()}.gif`}
                        height={100}
                        width={100}
                        alt={audience.type}
                        className="mx-auto mb-2"
                      />
                      <p className="font-semibold">{audience.type}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
              <p className="text-[#23282E]">
                Anyone and everyone who is genuinely interested to make money in
                the stock market can attend this webinar.
              </p>

              <div className="flex flex-col bg-[#F3F6FF] p-5 rounded-lg gap-1 border-l-2 border-black">
                <div className="flex flex-row justify-between items-center w-full">
                  <p className="font-semibold">Live Session</p>
                  <VideoCameraIcon className="w-11 h-11 bg-[#DEE7FF] p-2 rounded-full" />
                </div>
                <p className="text-[#8CA2C0]">
                  We provide live classes to our students. You can attend the
                  classes from anywhere in the world.
                </p>
              </div>
              <div className="flex flex-col bg-[#F3F6FF] p-5 rounded-lg gap-1 border-l-2 border-black w-full">
                <div className="flex flex-row justify-between items-center w-full">
                  <p className="font-semibold">Gamified Approach</p>
                  <PuzzlePieceIcon className="w-11 h-11 bg-[#DEE7FF] p-2 rounded-full" />
                </div>
                <p className="text-[#8CA2C0]">
                  We save all the session recordings in case you miss a class or
                  want to rewatch a class.
                </p>
              </div>
              <div className="flex flex-col bg-[#F3F6FF] p-5 rounded-lg gap-1 border-l-2 border-black">
                <div className="flex flex-row justify-between items-center w-full">
                  <p className="font-semibold">Win Prizes upto ₹10,000</p>
                  <TrophyIcon className="w-11 h-11 bg-[#DEE7FF] p-2 rounded-full" />
                </div>
                <p className="text-[#8CA2C0]">
                  Things are better when you do them with others. We have a
                  communities of 1000+ students who are learning together.
                </p>
              </div>
            </div>

            <div
              className="w-full flex flex-col justify-start items-start gap-4"
              ref={instructorRef}
            >
              <h4 className="text-[#002082] font-semibold">Instructor</h4>

              <div className="flex flex-row justify-start items-start gap-12 max-xl:gap-5 w-full border-2 border-[#E9EAF0] p-5">
                <Image
                  width={160}
                  height={160}
                  src={data?.masterClass?.bootcamp?.teacher?.photo}
                  alt="Teacher photo"
                  className="rounded-full max-xl:h-28 max-xl:w-28 max-lg:w-24 max-lg:h-24 object-cover"
                />
                <div className="flex flex-col justify-start items-start gap-4">
                  <div className="flex flex-col justify-start items-start">
                    <h4 className="font-semibold">
                      {data?.masterClass?.bootcamp?.teacher?.name}
                    </h4>
                    <p className="text-[#6E7485] text-[14px]">Trading Expert</p>
                  </div>
                  <div className="flex flex-row justify-start items-center max-lg:grid max-lg:grid-cols-2 max-lg:place-content-between max-lg:gap-3 gap-4 text-xs leading-tight">
                    <div className="flex flex-row justify-start items-center gap-1">
                      <StarIcon className="w-5 h-5" color="#FD8E1F" />
                      <p className="text-[#23282E]">
                        {" "}
                        {
                          data?.masterClass?.bootcamp?.teacher?.achievements
                            ?.rating
                        }{" "}
                        <span className="text-[#4E5566]">
                          <span className="max-xl:hidden">Instructor</span>{" "}
                          Rating
                        </span>
                      </p>
                    </div>
                    <div className="flex flex-row justify-start items-center gap-1">
                      <ChatBubbleOvalLeftEllipsisIcon className="w-5 h-5 text-[#23282E]" />
                      <p className="text-[#23282E]">
                        {" "}
                        {
                          data?.masterClass?.bootcamp?.teacher?.achievements
                            ?.reviews
                        }{" "}
                        <span className="text-[#4E5566]">Reviews</span>
                      </p>
                    </div>
                    <div className="flex flex-row justify-start items-center gap-1">
                      <UserIcon className="w-5 h-5" color="#564FFD" />
                      <p className="text-[#23282E]">
                        {" "}
                        {
                          data?.masterClass?.bootcamp?.teacher?.achievements
                            ?.students
                        }{" "}
                        <span className="text-[#4E5566]">Students</span>
                      </p>
                    </div>
                    <div className="flex flex-row justify-start items-center gap-1">
                      <PlayCircleIcon className="w-5 h-5" color="#FF6636" />
                      <p className="text-[#23282E]">
                        {" "}
                        {
                          data?.masterClass?.bootcamp?.teacher?.achievements
                            ?.courses
                        }{" "}
                        <span className="text-[#4E5566]">Courses</span>
                      </p>
                    </div>
                  </div>
                  <p className="text-[#6E7485] text-[14px]">
                    {data?.masterClass?.bootcamp?.teacher?.bio?.length > 250
                      ? data?.masterClass?.bootcamp?.teacher?.bio?.substring(
                          0,
                          251
                        )
                      : data?.masterClass?.bootcamp?.teacher?.bio}
                    {data?.masterClass?.bootcamp?.teacher?.bio?.length >
                      250 && (
                      <button
                        className={`border-none p-0 ${
                          expandTeacherInfo ? "hidden" : ""
                        }`}
                        onClick={() => setExpandTeacherInfo(!expandTeacherInfo)}
                      >
                        ...read more
                      </button>
                    )}
                    {expandTeacherInfo && (
                      <React.Fragment>
                        <span>
                          {data?.masterClass?.bootcamp?.teacher?.bio?.substring(
                            251
                          )}
                        </span>
                        <button
                          className={`border-none p-0 ${
                            !expandTeacherInfo ? "hidden" : ""
                          }`}
                          onClick={() =>
                            setExpandTeacherInfo(!expandTeacherInfo)
                          }
                        >
                          ...read less
                        </button>
                      </React.Fragment>
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div ref={helpRef}>
              <h4 className="text-[#002082] font-semibold">Help</h4>
              <Help
                data={data}
                type={CLASS_TYPE.MASTERCLASS}
                offerEndTime={offerEndTime}
              />
            </div>

            <div ref={reviewRef}>
              <Reviews
                data={data}
                type={CLASS_TYPE.MASTERCLASS}
                offerEndTime={offerEndTime}
              />
            </div>
          </div>

          <div className="max-w-sm max-lg:max-w-[300px] w-full sticky top-[5.5rem] shadow-md p-3 md:border-[#E9EAF0] md:border-[1px]">
            <NewLeadForm
              data={data}
              scroll={scroll}
              offerEndTime={offerEndTime}
            />
          </div>
        </div>

        <div className="flex flex-col md:hidden">
          <div className="flex flex-row gap-8 justify-center items-center bg-[#F8F8F8] py-2 mt-2 overflow-x-auto px-4 -mx-4 hide_scrollbar">
            {TabsArray.map((item: any, index: number) => {
              return (
                <div
                  className={`rounded-full tab-item w-24 border-none text-lg font-semibold flex flex-col gap-1 justify-center items-center hover:cursor-pointer ${
                    isActive === item.tab
                      ? "!text-[#002082] tab-item-active"
                      : "!text-[#161C2B]"
                  }`}
                  onClick={() => {
                    setIsActive(item.tab);
                    mixpanel.track("view_info", {
                      location: "tab",
                      tab: item?.tab,
                    });
                  }}
                  key={index}
                >
                  <Image
                    width={24}
                    height={24}
                    src={isActive === item.tab ? item.activeImg : item.img}
                    className={`${isActive === item.tab ? "scale-125" : ""} `}
                    alt="icon"
                  />
                  <small className="font-semibold">
                    {item.tab.substring(0, 1).toUpperCase() +
                      item.tab.substring(1, item.tab.length)}
                  </small>
                </div>
              );
            })}
          </div>

          <div id="form">
            {isActive === TABS.OVERVIEW && (
              <Overview
                offerEndTime={offerEndTime}
                data={data}
                scroll={scroll}
                setIsActive={setIsActive}
                setScroll={setScroll}
              />
            )}
          </div>

          {isActive === TABS.INSTRUCTOR && (
            <Instructor
              offerEndTime={offerEndTime}
              data={data}
              scroll={scroll}
              setScroll={setScroll}
            />
          )}

          {isActive === TABS.REVIEW && (
            <Reviews
              offerEndTime={offerEndTime}
              data={data}
              scroll={scroll}
              setScroll={setScroll}
              type={CLASS_TYPE.MASTERCLASS}
            />
          )}

          {isActive === TABS.HELP && (
            <Help
              offerEndTime={offerEndTime}
              data={data}
              scroll={scroll}
              setScroll={setScroll}
              type={CLASS_TYPE.MASTERCLASS}
            />
          )}
        </div>
        <div ref={button2Ref} className="h-2" />

        {/* Fixed CTA */}
        <div
          className={cn(
            "fixed right-0 -bottom-2 flex justify-between items-center w-full font-sans py-5 px-4 min-h-16 bg-white z-40 pb-4 transition-all duration-200 ease-out border-0 shadow-[0px_-2px_8px_0px_rgba(99,99,99,0.20)]",
            buttonVisibility.button1Visible || buttonVisibility.button2Visible
              ? "translate-y-full"
              : "translate-y-0"
          )}
        >
          <div className="">
            <div className="relative flex gap-2 items-center text-[#0A2133] font-semibold text-2xl">
              Free{" "}
              <div className="flex flex-col justify-center text-[#606060] text-sm before:content-[url('/masterclass-card-strike-through.svg')] before:absolute before:left-16 before:bottom-1">
                ₹499
              </div>
            </div>
            <p className="text-[#0A2133]">
              Offer Expires in{" "}
              <TimerOnlyText
                tillDateTime={offerEndTime}
                className="text-[#FF7426] font-semibold"
              />
            </p>
          </div>

          <Button
            className="bg-[#0A2133] !text-white border-none h-12 text-lg rounded"
            onClick={() => {
              setScroll(true);
              mixpanel.track("register_now", {
                page_referrer: document.referrer,
                location: "fixed_cta",
                masterclass: data?.masterClass?.title,
                source: "tradewise",
              });
            }}
          >
            Register Now
          </Button>
        </div>

        <FAQ />
      </Layout>
    </>
  );
}
